import { createFileRoute } from '@tanstack/react-router';

import { AuthorEditPage } from '@/components/admin/author-edit-page';
import { useAdminEditPageKey } from '@/hooks/use-admin-navigate';
import { adminHead } from '@/lib/seo';
import { adminGetAuthorFn } from '@/server/functions/admin';

export const Route = createFileRoute('/_admin/admin/authors_/$id')({
    component: AuthorEditRoute,
    head: ({ params }) =>
        adminHead(
            params.id === 'new' ? 'כותב חדש' : 'עריכת כותב',
            `/admin/authors/${encodeURIComponent(params.id)}`,
        ),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: async ({ params }) => {
        if (params.id === 'new') return null;
        return adminGetAuthorFn({ data: { id: params.id } });
    },
});

function AuthorEditRoute() {
    const author = Route.useLoaderData();
    const formKey = useAdminEditPageKey(
        author ? `${author.id}:${String(author.updatedAt)}` : undefined,
    );
    return <AuthorEditPage key={formKey} author={author} />;
}
